/**
 * Extrait une valeur de champ d'un formulaire HSFC.
 *
 * Recherche en priorité :
 * 1. Un input avec name exact (ex: input[name="phone"] — cas des hidden fields)
 * 2. Un input avec name suffixé "/fieldName" (ex: input[name="0-1/phone"] — champ visible HSFC)
 *
 * Retourne '' si aucun des deux n'existe ou n'a de valeur.
 */
export function extractField(form: HTMLFormElement, fieldName: string): string {
  const exact = form.querySelector<HTMLInputElement>(`input[name="${fieldName}"]`);
  if (exact?.value) return exact.value;

  const withPrefix = form.querySelector<HTMLInputElement>(`input[name$="/${fieldName}"]`);
  if (withPrefix?.value) return withPrefix.value;

  return '';
}
